import socketIOClient from "socket.io-client";
import _isEmpty from "lodash/isEmpty";
import {
  CONNECTED,
  CONNECTIVITY_SAMPLING_SIZE,
  ConnectivityState,
  DISCONNECTED,
  DTGS,
  DTGS_EVENTS,
  NAVIGATOR_LOADED,
  SOCKET_CLIENT_DISCONNECT_REASON,
  SOCKET_INFO,
  THREEP_SOCKET,
  THRESHOLD_LATENCY,
} from "../../utils/helpers/constants";
// import translations from 'utils/helpers/localization'
// import { hideLoader, showAlert, showLoader } from 'screens/commonAction/Actions'
// import NetInfo from '@react-native-community/netinfo'
import {
  getGameplaySpEventData,
  parseString,
} from "../../utils/helpers/common";
// import { getCurrentRoute, navigateToLudoboard, navigationRef, replace } from 'navigators/RootNavigation'
// import { NAVIGATION_ROUTES } from 'navigators/constants'
// import { hideSkipBox, resetGameplayState, updateLudoboardInternetConnectivity } from 'screens/gameplay/store/actions'
// import logger, { eventMetaData, TAG_NAMES } from 'utils/Logger'
// import { DeviceEventEmitter } from 'react-native'
import { EventEmitter } from "events";
// import { getDelaySocketReconnection } from 'classes/session/SessionManager'
// import { ALERT_TYPE } from 'screens/commonAction/Constants'
// import { getToken } from 'utils/helpers/token'
import _get from "lodash/get";
// import { checkInternet } from 'components/noInternetModal/useCheckInternet'
// import { isPlayerOnLudoboard, isPlayerOnWinnerScreen } from './helper'
// import { getMTTProgress } from 'utils/helpers/gameplay'
import _isNil from "lodash/isNil";
import { Socket } from "socket.io-client";
import { getNetworkInfo } from "../../utils/NetInfo";
import {
  createEventProcessor,
  getEventProcessor,
} from "../../pages/GamePlay/eventProcessor";
import { GameplayServer } from "../../interfaces/TournamentsConfig";
import { isPlayerOnLudoboard } from "./helper";
import { NAVIGATION_ROUTES } from "../../constant";
import { useNavigate } from "react-router-dom";
import React from "react";
import { navigate } from "../../utils/helpers/NavigationService";
// import { createEventProcessor, destroyEventProcessor, getEventProcessor } from 'screens/gameplay/eventProcessor'
// import { stopMusic } from 'classes/sound'
// import { storeData } from 'utils/helpers/asyncStorageUnsecure'
// import { CN_COUNT_FOR_CURRENT_GAME } from 'screens/gameplay/constants'
// import { CONTEXTUAL_NUDGE_TYPE } from 'screens/gameplay/types'
// import { getNetworkInfo } from '../../utils/NetInfo'
// import { ALERT_TYPE } from '../../components/GamePlayComponents/constant'
// import { parseString } from '../../utils/helpers/common'

const SOCKET_CONNECT_WAIT_TIMEOUT = 25000;
const SOCKET_RECONNECTION_PERIOD_IN_MS = 5000;
const RECONNECTION_MAX_ATTEMPTS = 120;
const LOW_RECONNECTION_THRESHOLD = 0;
const DeviceEventEmitter = new EventEmitter();

interface STATE_TYPES {
  onAuthenticated: null | Function;
  connectivityState: null | string;
  latencyCounter: number;
  previousLatency: number;
  socket: null | any;
  isConnecting: boolean;
  connectionTimeout: null | ReturnType<typeof setTimeout>;
  jtTimeout: null | ReturnType<typeof setTimeout>;
  dispatch: null | Function;
  gameplayServer: null | any;
  connectWaitTimeout: ReturnType<typeof setTimeout> | null;
  waitingForNavigator: false;
  listener: null | any;
  totalSocketDisconnectionInAGame: 0;
  isFirstReconnectionAttempt: boolean;
  isReconnectionRunning: boolean;
  reconnectTimer: null | ReturnType<typeof setTimeout>;
  isGameplayStopped: boolean;
  dtsListener: null | any;
  deviceEventHandler: { remove: () => void } | null;
}

const INITIAL_STATE: STATE_TYPES = {
  onAuthenticated: null,
  connectivityState: null,
  latencyCounter: 1,
  previousLatency: 0,
  socket: null,
  isConnecting: false,
  connectionTimeout: null,
  jtTimeout: null,
  dispatch: null,
  gameplayServer: null,
  connectWaitTimeout: null,
  waitingForNavigator: false,
  listener: null,
  totalSocketDisconnectionInAGame: 0,
  isFirstReconnectionAttempt: true,
  isReconnectionRunning: false,
  reconnectTimer: null,
  isGameplayStopped: false,
  dtsListener: null,
  deviceEventHandler: null,
};

let _state = { ...INITIAL_STATE };


function isTBIDPresentAndDifferent(currTBID?: string, newTBID?: string) {
  return !(_isEmpty(currTBID) && _isEmpty(newTBID) && currTBID === newTBID);
}

function setConnectWaitTimeout() {
  _state.connectWaitTimeout = setTimeout(() => {
    // logger(TAG_NAMES.LS_GAMEPLAY, 'Executing connect wait timeout', {
    //   isBreadcrumb: true
    // })
    // logger(TAG_NAMES.LS_GAMEPLAY, 'Releasing isConnecting lock')
    _state.isConnecting = false;
    destroySocket(true);
    connectSocket();
  }, SOCKET_CONNECT_WAIT_TIMEOUT);
}

export function initializeGameplaySocket(
  gameplayServer: GameplayServer | undefined,
  onAuthenticated: any
) {
  // if (_state.socket?.connected && !isTBIDPresentAndDifferent(gameplayServer.tbid, _state.gameplayServer.tbid)) {
  if (_state.socket?.connected) {
    // logger(TAG_NAMES.LS_GAMEPLAY, 'TableId changed destroying socket', {
    //   isBreadcrumb: true,
    //   isLogDataToFile: true,
    //   data: { prevTableId: _state?.gameplayServer?.tbid, newTableId: gameplayServer?.tbid }
    // })
    destroySocket();
  } else {
    // logger(TAG_NAMES.LS_GAMEPLAY, 'TableId Unchanged using same socket', {
    //   isBreadcrumb: true,
    //   isLogDataToFile: true,
    //   data: { prevTableId: _state?.gameplayServer?.tbid, newTableId: gameplayServer?.tbid }
    // })
  }
  _state.onAuthenticated = onAuthenticated;
  _state.gameplayServer = gameplayServer;

  // if (navigationRef?.current?.navigate) {
  connectSocket("Invoked directly");
  // } else {
  //   _state.listener = DeviceEventEmitter.addListener(NAVIGATOR_LOADED, handleNavigatorLoaded)
  //   _state.waitingForNavigator = true
  // }
}

// export function handleNavigatorLoaded() {
//   if (_isEmpty(_state.gameplayServer) || !_state.waitingForNavigator) {
//     // logger(TAG_NAMES.LS_GAMEPLAY, 'Navigator loaded event fired but we did not connect', {
//     //   isBreadcrumb: true,
//     //   isLogDataToFile: true,
//     //   data: { gameplayServer: _state.gameplayServer, waitingForNavigator: _state.waitingForNavigator }
//     // })
//     return
//   }
//   _state.waitingForNavigator = false
//   if (_state.listener) {
//     _state.listener?.remove()
//     _state.listener = null
//   }
//   connectSocket()
// }

export function connectSocket(
  invokeLog: string = "Invoked from event listener"
) {
  // logger(TAG_NAMES.LS_GAMEPLAY, invokeLog, {
  //   isBreadcrumb: true
  // })
  // if (_state.connectionTimeout) {
  //   logger(TAG_NAMES.LS_GAMEPLAY, 'Not connecting due to connection timeout already set')
  //   return
  // }

  _state.connectionTimeout = setTimeout(async () => {
    if (_state.isConnecting) {
      // logger(TAG_NAMES.LS_GAMEPLAY, 'Ignoring connect socket, to avoid race condition', {
      //   isBreadcrumb: true
      // })
      _state.connectionTimeout = null;
      return;
    }
    // logger(TAG_NAMES.LS_GAMEPLAY, 'Acquired isConnecting lock')
    _state.isConnecting = true;
    await handleSocketConnection();
    _state.connectionTimeout = null;
  }, 0);
}

async function handleSocketConnection() {
  if (_state.socket) {
    if (_state.socket.connected) {
      // logger(TAG_NAMES.LS_GAMEPLAY, 'Already connected to gameplay socket', {
      //   isBreadcrumb: true
      // })
      if (_state.connectWaitTimeout) {
        clearTimeout(_state.connectWaitTimeout);
        _state.connectWaitTimeout = null; // Optionally reset after clearing
      }
      // logger(TAG_NAMES.LS_GAMEPLAY, 'Releasing isConnecting lock')
      _state.isConnecting = false;
      return;
    }
    reconnectSocket();
    return;
  }
  if (_isNil(_state.gameplayServer)) {
    // logger(TAG_NAMES.LS_GAMEPLAY, 'Not connecting due to gameplayServer is nil. Releasing isConnecting lock', {
    //   isAddEvent: true,
    //   isLogToFile: true,
    //   isBreadcrumb: true
    // })
    _state.isConnecting = false;
    return;
  }
  const { proto, host, port } = _state.gameplayServer;

  if (_isEmpty(proto) || _isEmpty(host) || _isEmpty(port)) {
    // logger(TAG_NAMES.LS_GAMEPLAY, 'Empty gameplayServer', {
    //   isAddEvent: true,
    //   isLogToFile: true,
    //   data: _state.gameplayServer
    // })
  } else {
    // logger(TAG_NAMES.LS_GAMEPLAY, `Trying to connect to ${proto}://${host}:${port}`, {
    //   isBreadcrumb: true,
    //   isLogDataToFile: true,
    //   data: { ng_idx: _state.gameplayServer?.ng_idx, ng_ipx: _state.gameplayServer?.ng_ipx }
    // })
    const spQuery = await getGameplaySpEventData();
    // var str = encoder.write(buf).finalize();

    const str = "99VMCXJ4EHX4EYHFCNSNGCSMDN1Q6P1P8XVPYCBJ9SH6EY2R8SAN8CKBEDQPTY3D6XV52P3H8H4Q8WTA9NM4GN28B1J78XAQ6174MV0"

    _state.socket = socketIOClient(`${proto}://${host}:${port}`, {
      reconnection: false,
      timeout: 20000,
      transports: ['websocket'],
      // transportOptions: {
      //   polling: {
      //     extraHeaders: {
      //       "ng-idx": String(_state.gameplayServer.ng_idx),
      //       "ng-ipx": base32.encode(str),
      //       // "mode": "no-cors",
      //       "authorization": spQuery.lastAccessToken,
      //       "Access-Control-Allow-Origin": "*"
      //     },
      //   },
      // },
      // auth: {
      //   token: spQuery.lastAccessToken
      // },
      query: {
        ...spQuery,
        ng_idx: String(_state.gameplayServer.ng_idx),
        ng_ipx: _state.gameplayServer.ng_ipx,
        "ng-ipx": _state.gameplayServer.ng_ipx,
        "ng-idx": '0',
        // "mode": "no-cors",
        // "authorization": spQuery.lastAccessToken,
        // "Access-Control-Allow-Origin": "*"
      },
      // @ts-ignore
      // extraHeaders: {
      //   "ng-idx": String(_state.gameplayServer.ng_idx),
      //   "ng-ipx": base32.encode(str),
      //   //  "mode": "no-cors",
      //   "authorization": spQuery.lastAccessToken,
      //   "Access-Control-Allow-Origin": "*"
      // }
    });
    setConnectWaitTimeout();

    _state.socket.on("connect_timeout", (error: any) => {
      // logger(TAG_NAMES.LS_GAMEPLAY, 'Releasing isConnecting lock')
      _state.isConnecting = false;
      // logger(TAG_NAMES.LS_GAMEPLAY, `handleFailure connect_timeout`, { error })
    });
    _state.socket.on("error", handleError.bind(_state, "ERROR"));
    _state.socket.on(
      "connect_error",
      handleError.bind(_state, "CONNECT ERROR")
    );
    _state.socket.on("res", handleEvents.bind(_state));
    _state.socket.on("connect", handleConnect.bind(_state));
    // _state.socket.on('pong', handlePongEvent.bind(_state))
    _state.socket.on("disconnect", handleDisconnect.bind(_state));
  }
}

async function reconnectSocket() {
  // logger(TAG_NAMES.LS_GAMEPLAY, 'Retry gameplay socket connection', {
  //   isBreadcrumb: true
  // })
  _state.socket.io.opts.query = {
    ...(await getGameplaySpEventData()),
    ng_idx: _state.gameplayServer.ng_idx,
    ng_ipx: _state.gameplayServer.ng_ipx,
    "ng-ipx": _state.gameplayServer.ng_ipx,
    "ng-idx": '0',
  };
  _state.socket.connect();
  setConnectWaitTimeout();
}

export function destroySocket(keepContext: boolean = false) {
  // reset the flags and timeouts
  if (_state.connectWaitTimeout) {
    clearTimeout(_state.connectWaitTimeout);
    _state.connectWaitTimeout = null; // Optionally reset after clearing
  }
  console.log("Turning socket off")
  _state.socket?.off();
  console.log("Disconnecting socket")
  _state.socket?.disconnect();
  console.log("Remove dts listener")
  if (_state?.dtsListener) {
    console.log('Removing dtsListener using removeListener()...');
    DeviceEventEmitter.removeListener('DTGS', _state.dtsListener); // Correct method
    _state.dtsListener = null; // Clean up reference
  } else {
    console.warn('dtsListener is not defined or is null');
  }
  console.log("Resetting socket state")
  _state = {
    ...INITIAL_STATE,
    ...(keepContext
      ? {
          gameplayServer: _state.gameplayServer,
          onAuthenticated: _state.onAuthenticated,
        }
      : {}),
  };
}
export function disconnectSocket() {
  /** Please avoid heavy operations like
   *  1. Network call
   *  2. Disk IO i.e. Filelogger write
   *  3. OSLog
   *  4. anything that require system resourlce.
   *  This function is only called when app is about to be terminated due to crisis of resource
   */
  _state.socket?.disconnect();
}

export function emit(data: any) {
  if (_state.socket?.connected) {
    _state.socket.emit("req", data);
  }
}

function stopSocketReconnection(message: string) {
  if (_state.reconnectTimer) {
    clearTimeout(_state.reconnectTimer);
    _state.reconnectTimer = null;
  }
  _state.isReconnectionRunning = false;
  // logger(TAG_NAMES.LS_GAMEPLAY, `stopSocketReconnectionFromError => ${message}`)
}

// function reconnectionLinear(delaySocketReconnection: number, reconnectCounter: number) {
//   reconnectCounter--

//   logger(TAG_NAMES.LS_GAMEPLAY, `ReconnectionLinear attempt: ${reconnectCounter}}`)
//   if (isSocketConnected()) {
//     stopSocketReconnection('Socket has connected')
//     return
//   }

//   if (!checkInternet().isInternetWorking) {
//     stopSocketReconnection('No internet')
//     return
//   }

//   if (reconnectCounter < LOW_RECONNECTION_THRESHOLD) {
//     // showAlert('translations.reconnectionFailed', ALERT_TYPE.ERROR)
//     gameplayUnmount()
//   } else {
//     const timeoutDelay = _state.isFirstReconnectionAttempt ? delaySocketReconnection : SOCKET_RECONNECTION_PERIOD_IN_MS
//     _state.isFirstReconnectionAttempt = false

//     clearTimeout(_state.reconnectTimer)
//     _state.reconnectTimer = setTimeout(() => {
//       if (isSocketConnected()) {
//         stopSocketReconnection('Socket has connected stop the reconnectTimer')
//         return
//       }

//       if (!checkInternet().isInternetWorking) {
//         stopSocketReconnection('No internet stop the reconnectTimer')
//         return
//       }

//       if (_state.isGameplayStopped) {
//         logger(TAG_NAMES.LS_GAMEPLAY, 'Stop reconnectTimer since Gameplay has stopped')
//         return
//       }

//       connectSocket('Invoked From Error')
//       reconnectionLinear(delaySocketReconnection, reconnectCounter)
//     }, timeoutDelay)
//   }
// }

async function handleError(errorType: any, err: any) {
  console.log("handleError ===>", { errorType, err });
  // logger(TAG_NAMES.LS_GAMEPLAY, `handleGameplayFailure ${errorType}:: ${err}`, { isBreadcrumb: true })
  if (_state.connectWaitTimeout) {
    clearTimeout(_state.connectWaitTimeout);
    _state.connectWaitTimeout = null; // Optionally reset after clearing
  }
  // logger(TAG_NAMES.LS_GAMEPLAY, 'Releasing isConnecting lock')
  _state.isConnecting = false;

  if (_state.isReconnectionRunning) {
    //While reconnection is running don't call duplicate reconnectionLinear
    // logger(TAG_NAMES.LS_GAMEPLAY, 'Return reconnection is already running')
    return;
  }
  // if ((await getNetworkInfo().isConnected)) {
  //   // const delaySocketReconnection = getDelaySocketReconnection()
  //   _state.isReconnectionRunning = true
  //   reconnectionLinear(delaySocketReconnection, RECONNECTION_MAX_ATTEMPTS)
  // }
}

function handleDtsEvent(data: { en: string; data: any }) {
  switch (data.en) {
    case DTGS_EVENTS.EMIT:
      emit(data.data);
      break;
    case DTGS_EVENTS.DESTROY:
      gameplayUnmount();
      break;
    default:
    // logger(TAG_NAMES.LS_GAMEPLAY, `Unknown dts event: ${data}`)
  }
}

function handleConnect() {

  if (_state.connectWaitTimeout) {
    clearTimeout(_state.connectWaitTimeout);
    _state.connectWaitTimeout = null; // Optionally reset after clearing
  }
  // logger(TAG_NAMES.LS_GAMEPLAY, 'Releasing isConnecting lock')
  _state.isConnecting = false;
  _state.isFirstReconnectionAttempt = true;
  _state.isReconnectionRunning = false;
  // logger(TAG_NAMES.LS_GAMEPLAY, `Gameplay Socket connect with id: ${_state.socket?.id}`)
  // hideLoader()
  // eventMetaData(SOCKET_INFO, THREEP_SOCKET, CONNECTED)
  // _state.deviceEventHandler?.remove();
  // _state.dtsListener = DeviceEventEmitter.addListener(DTGS, handleDtsEvent);
  _state.dtsListener = handleDtsEvent;
DeviceEventEmitter.addListener('DTGS', handleDtsEvent);
  console.log("_state", _state)
}

function handleDisconnect(reason: string) {
  // showLoader(translations.reconnecting)
  // showLoader("reconnecting")

  if (SOCKET_CLIENT_DISCONNECT_REASON !== reason) {
    connectSocket("Invoked from disconnect");
  }
  _state.totalSocketDisconnectionInAGame += 1;
  // eventMetaData(SOCKET_INFO, THREEP_SOCKET, DISCONNECTED)
}

// export const connectGameplaySocketOnNetworkChange = async () => {
//   const token = await getToken()
//   const accessToken = _get(token, 'accessToken', '')
//   if (_isEmpty(accessToken) || _state.socket === null) {
//     logger(TAG_NAMES.LS_GAMEPLAY, `User is not logged in isGameplaySocketCreated ${_state.socket !== null}`, {
//       isBreadcrumb: true,
//       isLogToFile: false
//     })
//     return
//   }

//   logger(TAG_NAMES.LS_GAMEPLAY, 'Connect gameplay socket on network change', {
//     isBreadcrumb: true
//   })
//   connectSocket('Invoked on network or appstate change')
// }

const incrementLatencyCounter = (latency: number) => {
  if (
    (_state.previousLatency >= THRESHOLD_LATENCY &&
      latency >= THRESHOLD_LATENCY) ||
    (_state.previousLatency < THRESHOLD_LATENCY && latency < THRESHOLD_LATENCY)
  ) {
    _state.latencyCounter += 1;
  }
};

// function handlePongEvent(latency: number) {
//   if (!isPlayerOnLudoboard()) {
//     return
//   }

//   incrementLatencyCounter(latency)

//   // if (latency >= THRESHOLD_LATENCY && _state.latencyCounter >= CONNECTIVITY_SAMPLING_SIZE) {
//   //   // trigger a feedback - poor connection
//   //   logger(TAG_NAMES.LS_GAMEPLAY, 'POOR GAME CONNECTION')
//   //   _state.latencyCounter = 1
//   //   _state.connectivityState = ConnectivityState.WEAK
//   //   updateLudoboardInternetConnectivity(ConnectivityState.WEAK)
//   //   // sendInternetInfoToUnity(ConnectivityState.WEAK)
//   // } else if (_state.latencyCounter >= CONNECTIVITY_SAMPLING_SIZE) {
//   //   // trigger a feedback - stable connection
//   //   logger(TAG_NAMES.LS_GAMEPLAY, 'STABLE GAME CONNECTION')
//   //   _state.latencyCounter = 1
//   //   if (_state.connectivityState === ConnectivityState.WEAK) {
//   //     updateLudoboardInternetConnectivity(ConnectivityState.STABLE)
//   //   } else {
//   //     updateLudoboardInternetConnectivity(null)
//   //   }
//   //   _state.connectivityState = ConnectivityState.STABLE
//   // }
//   _state.previousLatency = latency
// }

// export function internetIsBackWhileGameplay() {
//   if (!isPlayerOnLudoboard()) {
//     return
//   }
//   _state.connectivityState = ConnectivityState.WEAK
//   _state.latencyCounter += 1
//   // updateLudoboardInternetConnectivity(ConnectivityState.UNSTABLE)
// }

export function stopGameplay() {
  // logger(TAG_NAMES.LS_GAMEPLAY, 'Stop Gameplay')
  destroySocket();
  stopSocketReconnection("From gameplayUnmount");
  _state.isGameplayStopped = true;
}

// function handleEvents(res: any) {
//   console.log(res, '<><><>handleEvents');
// }

function handleEvents(res: any) {
  // logger(TAG_NAMES.LS_GAMEPLAY, `handleGameplayEvents`, {
  //   isBreadcrumb: true,
  //   isLogToFile: true,
  //   data: res
  // })
  switch (res.en) {
    case "SP":
      if (_state.onAuthenticated) {
        emit(parseString(_state.onAuthenticated))
        // Removing this from state as it is only for one time use. For rejoins it will created in below else if.
        _state.onAuthenticated = null
      } else
      if (res.data.rejoin) {
        emit(
          parseString({ en: "RJT", data: { _id: res.data._id, gt: "normal" } })
        );
      } else {
        if (res?.flag) {
          // logger(TAG_NAMES.LS_GAMEPLAY, 'SP CHECKS FAILED', {
          //   isAddEvent: true,
          //   isLogDataToFile: true
          // })
        } else {
          // logger(TAG_NAMES.LS_GAMEPLAY, 'GAMEPLAY SOCKET FAILED TO CONNECT', {
          //   isAddEvent: true,
          //   isLogDataToFile: true
          // })
        }
        gameplayUnmount();
        // if (!isPlayerOnWinnerScreen()) {
        //   replace(NAVIGATION_ROUTES.LOBBY)
        // }
      }
      break;
    case "GTI":
      if (res.flag === true) {
        const gameName = res.data?.gameplayServer?.gameName;
        if (!isPlayerOnLudoboard()) {
          console.log("<res?.data>", res?.data, gameName);
          navigate(NAVIGATION_ROUTES.GAMEPLAY);
          // navigate(NAVIGATION_ROUTES.GAMEPLAY, { replace: true });
          // navigateToLudoboard(res?.data?.boardType, gameName)
        }

        createEventProcessor(gameName);
        getEventProcessor()?.processGameTableInfo(res.data);
        // hideLoader()
      } else {
        // logger(TAG_NAMES.LS_GAMEPLAY, 'GTI Flag false', {
        //   isBreadcrumb: true,
        //   isLogDataToFile: true
        // })
        // hideLoader()
        // getMTTProgress()
        gameplayUnmount();
        // getCurrentRoute()?.name != NAVIGATION_ROUTES.LOBBY && replace(NAVIGATION_ROUTES.LOBBY)
      }
      break;
    // case 'JT':
    //   clearTimeout(_state.jtTimeout)
    //   _state.jtTimeout = null
    //   _state.jtTimeout = setTimeout(() => {
    //     if (!_state.socket?.connected) {
    //       // logger(TAG_NAMES.LS_GAMEPLAY, 'Socket disconnected within 5 secs after receiving Join Table', {
    //       //   isAddEvent: true,
    //       //   isBreadcrumb: true
    //       // })
    //     }
    //     clearTimeout(_state.jtTimeout)
    //     _state.jtTimeout = null
    //   }, 5000)
    //   getEventProcessor()?.processJoinTable(res.data)
    //   break

    case "RTS":
      getEventProcessor()?.processRoundTimerStarted();
      break;

    case "CB":
      getEventProcessor()?.processCollectBootValue();
      break;

    case "UTS":
      getEventProcessor()?.processUserTurnStarted(res.data);
      break;

    case "TUT":
      getEventProcessor()?.processTurnUserTimeout(
        res.data,
        _state.totalSocketDisconnectionInAGame
      );
      break;

    case "AD":
      getEventProcessor()?.processAnimateDice("socket");
      break;

    case "MUK": {
      getEventProcessor()?.processMoveUserKukari(res.data);
      break;
    }

    case "TBL": {
      getEventProcessor()?.processTimeBankLeft(res.data);
      break;
    }

    case "LT":
      getEventProcessor()?.processLeaveTable(res.data);
      break;

    case "WD":
      getEventProcessor()?.processWinnerDeclared(res.data);
      break;

    case "LAST_MOVE":
      getEventProcessor()?.processLastMove(res.data);
      break;
    default:
      // addLogs(`<===== GAMEPLAY SOCKET UNKNOWN EVENT RECEIVED ${res.en} =====>`)
      break;
  }
}

export function isSocketConnected() {
  return _state.socket?.connected;
}

export default function gameplayUnmount() {
  // logger(TAG_NAMES.LS_GAMEPLAY, 'Gameplay unmount called', {
  //   isBreadcrumb: true
  // })
  stopGameplay();
  // stopMusic()
  // hideSkipBox()
  setTimeout(() => {
    // resetGameplayState()
  }, 1000);
  // destroyEventProcessor()
}
